<template>
	<div>
		<a-divider orientation="left">监控报表</a-divider>
		<a-space  :size="45"  style="padding:1.5rem;">
			<a-card  hoverable style="width: 12.5rem;" @click="showFlowStatisView"> 
				<img slot="cover" alt="example" src="../assets/table.png"/>
				<a-card-meta title="时/日/月/年流量统计"></a-card-meta>
			</a-card>
			<a-card  hoverable style="width: 12.5rem;" @click="showMonitorLinkView">
				<img slot="cover" alt="example" src="../assets/square.png"/>
				<a-card-meta title="站点链接情况"></a-card-meta>
			</a-card>
			<a-card  hoverable style="width: 12.5rem;" @click="showIntervalStatisView">
				<img slot="cover" alt="example" src="../assets/line.png"/>
				<a-card-meta title="间隔流量图形"></a-card-meta>
			</a-card>
			<a-card  hoverable style="width: 12.5rem;" @click="showYoYStatisView">
				<img slot="cover" alt="example" src="../assets/chart.png"/>
				<a-card-meta title="大表同环比分析"></a-card-meta>
			</a-card>
		</a-space>
		<a-divider orientation="left">其他报表</a-divider>
		<a-space  :size="45"  style="padding:1.5rem;">
			<a-card  hoverable style="width: 12.5rem;" @click="showMinFlowStatisView">
				<img slot="cover" alt="夜间最小流量分析" src="../assets/small_flow.png"/>
				<a-card-meta title="夜间最小流量分析"></a-card-meta>
			</a-card>
			<a-card  hoverable style="width: 12.5rem;" @click="showDetailInfoView">
				<img slot="cover" alt="数据详情查看" src="../assets/file.png"/>
				<a-card-meta title="数据详情查看"></a-card-meta>
			</a-card>
		</a-space>
		<MeterMonitorFlowStatis ref="flowStatisView"/>
		<MeterMonitorIntervalStatis ref="intervalStatisView"/>
		<MeterMonitorLinkView ref="linkView"/>
		<MeterMonitorYoYStatis ref="yoyStatisView"/>
		<MeterMonitorMinFlowStatis ref="minFlowStatisView"/>
		<MeterMonitorDetailView ref="detailView"/>
		
	</div>
</template>

<script>
	import MeterMonitorFlowStatis from '/src/components/MeterMonitorFlowStatis.vue'
	import MeterMonitorIntervalStatis from '/src/components/MeterMonitorIntervalStatis.vue'
	import MeterMonitorLinkView from '/src/components/MeterMonitorLinkView.vue'
	import MeterMonitorYoYStatis from '/src/components/MeterMonitorYoYStatis.vue'
	import MeterMonitorMinFlowStatis from '/src/components/MeterMonitorMinFlowStatis.vue';
	import MeterMonitorDetailView from '/src/components/MeterMonitorDetailView.vue'
	export default {
		components:{
			MeterMonitorFlowStatis,
			MeterMonitorIntervalStatis,
			MeterMonitorLinkView,
			MeterMonitorYoYStatis,
			MeterMonitorMinFlowStatis,
			MeterMonitorDetailView,
		},
		data(){
			return {
			}
		},
		methods:{
			//日、月、年报表统计
			showFlowStatisView:function(){
				this.$refs.flowStatisView.showView([],0);
			},
			//间隔流量图形
			showIntervalStatisView(){
				this.$refs.intervalStatisView.showView([],null,null);
			},
			//夜间最小流量分析
			showSmallFlowStatisView(){
				
			},
			//站点连接情况
			showMonitorLinkView(){
				this.$refs.linkView.showView();
			},
			//同环比分析报表
			showYoYStatisView(){
				this.$refs.yoyStatisView.showView();
			},
			showMinFlowStatisView(){
				this.$refs.minFlowStatisView.showView();
			},
			showDetailInfoView(){
				this.$refs.detailView.showView();
			},
		}
	}
</script>

<style>
</style>
